/** GSM-7 basic character set length estimate (simplified). */
const GSM7_BASIC_REGEX =
  /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,\-./0-9:;<=>?¡A-ZÄÖÑÜ§¿a-zäöñüà]*$/;

export const insertTokenAtCursor = (textarea, currentValue, token) => {
  if (!textarea) {
    return `${currentValue || ""}${token}`;
  }

  const start = textarea.selectionStart ?? currentValue.length;
  const end = textarea.selectionEnd ?? currentValue.length;
  const before = currentValue.slice(0, start);
  const after = currentValue.slice(end);
  const next = `${before}${token}${after}`;

  requestAnimationFrame(() => {
    const pos = start + token.length;
    textarea.focus();
    textarea.setSelectionRange(pos, pos);
  });

  return next;
};

export const resolveMessageWithSamples = (message, placeholders = []) => {
  if (!message) return "";
  let resolved = message;
  placeholders.forEach((p) => {
    const token = p.token ?? p.Token;
    const sample = p.sampleValue ?? p.SampleValue ?? "";
    if (token) resolved = resolved.split(token).join(sample);
  });
  return resolved;
};

export const estimateSmsSegments = (text) => {
  const value = text || "";
  const len = value.length;
  if (len === 0) {
    return { length: 0, segments: 0, isGsm7: true };
  }

  const isGsm7 = GSM7_BASIC_REGEX.test(value);
  const singleLimit = isGsm7 ? 160 : 70;
  const multiLimit = isGsm7 ? 153 : 67;
  const segments = len <= singleLimit ? 1 : Math.ceil(len / multiLimit);

  return { length: len, segments, isGsm7 };
};

export const truncateMessage = (text, maxLen = 80) => {
  if (!text) return "—";
  const trimmed = text.trim();
  if (trimmed.length <= maxLen) return trimmed;
  return `${trimmed.slice(0, maxLen)}…`;
};
